import APIService from 'services/APIService'

const api = APIService()

export const getBookIsFreeTrialFlags = (course_original_id: string) =>
  api.get(`/book-courses/${course_original_id}/course-books`)
